module.exports = __webpack_public_path__ + "img/Empresa.2d8d8f95.png";